import React from "react";
import classnames from "classnames";
import "./SectionHeader.scss";

function SectionHeader(props) {
  // Render nothing if no title or subtitle
  if (!props.title && !props.subtitle) {
    return null;
  }

  return (
    <header
      className={classnames('SectionHeader', {
        [props.className]: props.className
      })}
    >
      {props.title && (
        <h1
          className={classnames('font-weight-bold', {
            'mb-2': props.subtitle && props.spaced,
            'mb-0': !props.subtitle,
            [`h${props.size}`]: props.size || 3,
          })}
        >
          {props.title}
        </h1>
      )}

      {props.subtitle && (
        <p className="SectionHeader__subtitle mb-0">{props.subtitle}</p>
      )}
    </header>
  );
}

export default SectionHeader;
